import { gql, useApolloClient } from "@apollo/client";

import type { UserType } from "@/components/user-search-modal/types";
import useAuth from "@/hooks/use-auth";

const QUERY = gql`
  query VerifyUserEscapeTag($gameId: ID!, $userId: ID!) {
    verifyUserEscapeTag(gameId: $gameId, userId: $userId) {
      escape {
        id
        game {
          id
          name
        }
      }
      user {
        id
        firstName
        imageId
        lastName
        username
      }
    }
  }
`;

export interface EscapeType {
  game?: {
    id: string;
    name: string;
  };
  id: string;
}

interface VerifyUserEscapeTagDataType {
  verifyUserEscapeTag: {
    escape?: EscapeType;
    user: UserType;
  };
}

interface VerifyUserEscapeTagVariablesType {
  gameId: string;
  userId: string;
}

export default function useVerifyUserEscapeTag() {
  const apollo = useApolloClient();
  const { queryContext } = useAuth();

  const query = async (variables: VerifyUserEscapeTagVariablesType) => {
    return await apollo.query<
      VerifyUserEscapeTagDataType,
      VerifyUserEscapeTagVariablesType
    >({
      ...queryContext(variables),
      fetchPolicy: "cache-first",
      query: QUERY,
    });
  };

  return query;
}
